import { Delegate } from "dom-delegate";
import { nodesToArray, addClass, removeClass } from "@pod-point/dom-ops";

let instances = [];
const IS_ACTIVE = "is-active";

class SelectToggle {
    /**
     * Creates a new toggle element.
     *
     * @param {HTMLElement} element
     */
    constructor(element) {
        this.element = element;
        this.elementId = element.getAttribute("id");

        const toggleTriggersSelector = `[data-toggle-el="${this.elementId}"]`;

        this.toggleTriggers = nodesToArray(document.querySelectorAll(toggleTriggersSelector)) || [];
        this.bindEvents();
    }

    /**
     * Binds the event listeners from the elements.
     *
     * @return {void}
     */
    bindEvents() {
        this.toggleListeners = [];
        this.toggleTriggers.forEach((toggleTrigger) => {
            const toggleListener = new Delegate(toggleTrigger);
            this.toggleListeners.push(toggleListener);

            toggleListener.on("change", (event, element) => {
                this.handleToggle(element);
            });
        });
    }

    /**
     * Handle the toggle decision.
     *
     * @param {HTMLElement} selectElement
     * @return {void}
     */
    handleToggle(selectElement) {
        const selectedVal = selectElement.options[selectElement.selectedIndex].value;

        if (selectedVal === "other") {
            this.openElement(this.element);
        } else {
            this.closeElement(this.element);
        }
    }

    /**
     * Handle the element opening.
     *
     * @return {void}
     */
    openElement() {
        addClass(this.element, IS_ACTIVE);
    }

    /**
     * Handle the element closing.
     *
     * @return {void}
     */
    closeElement() {
        removeClass(this.element, IS_ACTIVE);

        // Clear the input value if it exists and the element has `data-toggle-clear` attribute
        if (this.element.hasAttribute("data-toggle-clear") && this.element.querySelector("input")) {
            this.element.querySelector("input").value = "";
        }
    }

    /**
     * Unbinds the event listeners from the elements.
     *
     * @return {void}
     */
    unbindEvents() {
        this.toggleListeners.forEach((toggleListener) => toggleListener.destroy());
    }
}

export default {
    init: (element) => {
        instances.push(new SelectToggle(element));
    },

    destroy: () => {
        instances.forEach((instance) => instance.unbindEvents());
        instances = [];
    },
};
